import { Button, Container, Grid, TextField } from '@mui/material'
import React, { Fragment, useState } from 'react'

interface ModalAsnCommentProps {
  handleCloseModal: () => void
  requestCommentAsn: () => void
  setComment: (value: string) => void
  comment: string
}

export const ModalAsnComment: React.FC<ModalAsnCommentProps> = ({
  handleCloseModal,
  requestCommentAsn,
  setComment,
  comment
}) => {
  const [error, setError] = useState<string>('')
  const [commentError, setCommentError] = useState(false)

  const requestReceivedAsn = () => {
    if (!comment.trim()) {
      setError('Comentario es obligatorio')
      setCommentError(true)
    } else if (comment.trim().length < 5) {
      setError('Ingrese al menos 5 caracteres')
      setCommentError(true)
    } else {
      requestCommentAsn()
      setComment('')
      handleCloseModal()
    }
  }
  return (
    <Fragment>
      <Container style={{ textAlign: 'center' }}>
        <Grid container>
          <Grid item xs={12} style={{ padding: '10px' }}>
            <TextField
              rows={5}
              minRows={5}
              maxRows={5}
              variant='outlined'
              multiline
              fullWidth
              placeholder='Ingrese Comentario ...'
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              error={commentError}
              helperText={error}
            />
          </Grid>
          <Grid item xs={12}>
            <Button
              variant='contained'
              color='primary'
              onClick={() => requestReceivedAsn()}
              size='medium'
              disabled={!comment}
            >
              Confirmar Recepción
            </Button>
          </Grid>
        </Grid>
      </Container>
    </Fragment>
  )
}
